export default __webpack_public_path__ + "static/Latta-5b25256a42869019b2abf73a4067f997.jpg";